import { ENGLISH_IQ_SESSION_STORAGE_KEY } from './english-iq-session-storage-key';
import type { IEnglishIqStoredFlow } from './english-iq-stored-session';

export function persistEnglishIqSession(session: IEnglishIqStoredFlow | null): void {
  try {
    if (session) {
      localStorage.setItem(ENGLISH_IQ_SESSION_STORAGE_KEY, JSON.stringify(session));
      return;
    }
    localStorage.removeItem(ENGLISH_IQ_SESSION_STORAGE_KEY);
  } catch {}
}
